module.exports = __webpack_public_path__ + "static/media/Placeholder-Profilepicture.4a95a3e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/Placeholder-Profilepicture.jpg
// module id = 699
// module chunks = 2